import { apiRequest } from './apiRequest';

export const login = async (config, email, password) => {
  return apiRequest(config, '/auth/login', 'post', {
    email,
    password,
    admin: true,
    project: 1,
  });
};
